<template>
  <filter-summary
    icon="calendar"
    title="期間"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
  >
    <div>{{ summary }}</div>

    <div v-if="termType === 'select'">
      {{ selectByDate ? '対象日付' : '対象曜日' }}
    </div>
    <div v-if="termType === 'select'">
      {{ selectByDate ? selectedDatesJoined : selectedDaysJoined }}
    </div>
  </filter-summary>
</template>

<script>
import { toHumanFriendlyFormat } from '@/util/date'
import { SELECTED_DAY_OPTIONS } from '../const/termSelectOptions'

import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「期間」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    termType: {
      type: String,
    },
    dateFrom: {
      type: String,
    },
    dateTo: {
      type: String,
    },
    selectType: {
      type: String,
    },
    selectedDates: {
      type: Array,
    },
    selectedDays: {
      type: Array,
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      }
    },
    selectByDate() {
      return this.selectType === 'date'
    },
    summary() {
      if (this.dateFrom && this.dateTo) {
        return (
          toHumanFriendlyFormat(this.dateFrom) +
          ' ～ ' +
          toHumanFriendlyFormat(this.dateTo)
        )
      } else {
        return ''
      }
    },
    selectedDatesJoined() {
      return [...this.selectedDates]
        .sort((a, b) => a - b)
        .map(m => `${m}日`)
        .join(',')
    },
    selectedDaysJoined() {
      return [...SELECTED_DAY_OPTIONS]
        .filter(f => this.selectedDays.includes(f.id))
        .sort((a, b) => a.order - b.order)
        .map(m => m.label)
        .join(',')
    },
  },
}
</script>
